import { render, staticRenderFns } from "./Escolaridad.vue?vue&type=template&id=b4b0e8fe&scoped=true"
import script from "./Escolaridad.vue?vue&type=script&lang=js"
export * from "./Escolaridad.vue?vue&type=script&lang=js"
import style0 from "./Escolaridad.vue?vue&type=style&index=0&id=b4b0e8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b0e8fe",
  null
  
)

export default component.exports